/* eslint-disable no-restricted-globals */
const dataDownloaderWorker = () => {
  self.addEventListener("message", (event) => {
    if (!event) return;
    const {
      userCips,
      cips,
      cleaningEffectiness,
      fouling,
      benefitsInfo,
      annualBenefitsInfo,
      predictionandRecommendData,
      predictionDataRaw,
      others,
      totalbenefitWindow,
      annualBenefitsWindow,
      suggestedOthers,
    } = event.data.exportData;
    const { exportWorkerTransaltionString } = event.data.translations;
    const foulingType = event.data.foulingType;

    const getLanguageCode = {
      USD: {
        code: "en-US",
        currency: "USD",
        symbol: "$",
      },
      Yuan: {
        code: "zh-CN",
        currency: "CNY",
        symbol: "¥",
      },
      Euro: {
        code: "EUR",
        currency: "EUR",
        symbol: "€",
      },
    };

    const multipleReasonFormatter = (type) => {
      if (typeof type === "string") {
        type = type.split(",");
      }
      if (Array.isArray(type)) {
        const formattedType = type.map((item) => {
          const trimmedItem = item.trim();
          return trimmedItem;
        });
        const resultString = formattedType.join(", ");
        return resultString;
      }
      return type;
    };

    const reasonFormatter = (data, isPrimary = true) => {
      if (data?.length === 0) {
        return exportWorkerTransaltionString.noReason;
      } else {
        const { primary_reason, proportion1, secondary_reason, proportion2 } =
          data[0];
        const type = isPrimary ? primary_reason : secondary_reason;
        if (type) {
          const foulingTypeData = foulingType ? foulingType[type] : type;
          const propValue = parseFloat(isPrimary ? proportion1 : proportion2);
          const proportion =
            propValue && propValue > 0
              ? propValue < 10 && propValue % 1 !== 0
                ? `${propValue.toFixed(1)}%`
                : `${Math.round(propValue)}%`
              : "-";
          return `${foulingTypeData} (${proportion})`;
        } else {
          return "-";
        }
      }
    };

    const pressureFormatter = (value) => {
      const hasSuperscriptA = typeof value === "string" && value.includes("ᵃ");
      const hasSuperscriptB = typeof value === "string" && value.includes("ᵇ");

      const numericValue =
        hasSuperscriptA || hasSuperscriptB
          ? parseFloat(value.replace("ᵃ", "").replace("ᵇ", "").trim())
          : parseFloat(value);

      if (isNaN(numericValue)) {
        return "*";
      } else if (numericValue < 0) {
        return hasSuperscriptA ? "< 0 ᵃ" : hasSuperscriptB ? "< 0 ᵇ" : "< 0";
      } else if (numericValue > 100) {
        return hasSuperscriptA
          ? "> 100 ᵃ"
          : hasSuperscriptB
            ? "> 100 ᵇ"
            : "> 100";
      } else {
        return (Math.floor(numericValue * 10) / 10).toFixed(1);
      }
    };

    const dateFormatter = (date) => {
      if (date) {
        date = new Date(date);

        if (isNaN(date.getTime())) {
          return "Invalid Date";
        }
        const formattedDay = date.getDate().toString().padStart(2, "0");
        const formattedMonth = (date.getMonth() + 1)
          .toString()
          .padStart(2, "0");
        const formattedYear = date.getFullYear();

        return `${formattedDay}/${formattedMonth}/${formattedYear}`;
      } else return null;
    };

    const CIP_TYPE_FORMATTER_STRINGS = {
      CIP: "cip",
      SHUTDOWN: "shutdown",
      C: "c",
      S: "s",
      SHUTDOWN_AS_PREDICTED: "shutdown (as predicted)",
      SHUTDOWN_WITH_CIP: "shutdown with cip",
    };

    const typeFormatter = (type) => {
      if (!type) {
        return "";
      }

      const lowerValue = type.toLowerCase();

      switch (lowerValue) {
        case CIP_TYPE_FORMATTER_STRINGS.C:
        case CIP_TYPE_FORMATTER_STRINGS.CIP:
          return exportWorkerTransaltionString.cip;
        case CIP_TYPE_FORMATTER_STRINGS.S:
        case CIP_TYPE_FORMATTER_STRINGS.SHUTDOWN:
          return exportWorkerTransaltionString.shutdown;
        case CIP_TYPE_FORMATTER_STRINGS.SHUTDOWN_AS_PREDICTED:
          return exportWorkerTransaltionString.shutdownAsPredicted;
        case CIP_TYPE_FORMATTER_STRINGS.SHUTDOWN_WITH_CIP:
          return exportWorkerTransaltionString.shutdownWithCip;
        default:
          return "";
      }
    };

    const cipTypeFormatter = (value) => {
      const cipTypeValue = value?.toLowerCase();
      if (!cipTypeValue) return "-";

      const translationKey = exportWorkerTransaltionString[cipTypeValue];
      return translationKey || value;
    };

    const formattedCurrencyValue = (value) => {
      const currency = others[0].currency;
      const languageCurrency = getLanguageCode[currency].currency;
      const currencySymbol = getLanguageCode[currency].symbol;
      const currencyCode = getLanguageCode[currency].code;
      const isChineseCurrency = currencyCode === "zh-CN";

      if (!value) {
        return isChineseCurrency
          ? `${value}${currencySymbol}`
          : `${currencySymbol}${value}`;
      }

      let formattedValue = parseFloat(value).toLocaleString(currencyCode, {
        style: "currency",
        currency: languageCurrency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

      if (isChineseCurrency) {
        // Move symbol from start to end: ¥123.45 -> 123.45¥ or -¥123.45 -> -123.45¥
        const symbolChar = formattedValue.charAt(value > 0 ? 0 : 1);
        formattedValue =
          value > 0
            ? formattedValue.slice(1) + symbolChar
            : formattedValue.charAt(0) + formattedValue.slice(2) + symbolChar;
        // Keep ¥ as is
        // formattedValue = formattedValue.replace("¥", "¥");
      }

      return formattedValue;
    };

    const formatDecimal = (value) => {
      value = parseFloat(value);
      return value.toFixed(2);
    };

    const formatVolumeWithUnit = (value) => {
      const volume = others[0]?.volume;
      const unit = volume === "m3" ? "m³" : volume;
      const formattedValue = formatDecimal(value);
      return `${formattedValue} ${unit}`;
    };

    const cipSheetData = cips?.map((data, index) => {
      return {
        ...data,
        index: index + 1,
        start_date: dateFormatter(data.start_date),
        end_date: dateFormatter(data.end_date),
        type: typeFormatter(data.type),
        is_tool_identified: data.is_tool_identified
          ? exportWorkerTransaltionString.calculation
          : exportWorkerTransaltionString.user,
        acidPh: data.acid_cip_ph,
        acidTemperature: data.acid_cip_temp,
        acidDuration: data.acid_cip_duration,
        acidUsed: data.acid_used_per_cip,
        alkaliPh: data.alkali_cip_ph,
        alkaliTemperature: data.alkali_cip_temp,
        alkaliDuration: data.alkali_cip_duration,
        alkaliUsed: data.alkali_used_per_cip,
        solutionPh: data.cip_solution_ph,
        solutionTemperature: data.cip_solution_temp,
        solutionDuration: data.cip_solution_duration,
        solutionUsed: data.additional_chemical_per_cip,
        addInfo: data.add_info,
        cipType: cipTypeFormatter(data.cip_type),
      };
    });

    const cleaningEffectinessSheetData = cleaningEffectiness?.map(
      (data, index) => {
        return {
          ...data,
          index: index + 1,
          type: typeFormatter(data.type),
          start_date: dateFormatter(data.start_date),
          pressure_drop: pressureFormatter(data.pressure_drop),
          flow: pressureFormatter(data.flow),
          salt_passage: pressureFormatter(data.salt_passage),
          reason: multipleReasonFormatter(data.reason),
        };
      },
    );

    const foulingSheetData = fouling?.map((data, index) => {
      return {
        ...data,
        index: index + 1,
        type: typeFormatter(data.data[0].type),
        start_date: dateFormatter(data.start_date),
        end_date: dateFormatter(data.end_date),
        primary_reason: reasonFormatter(data?.data, true),
        secondary_reason: reasonFormatter(data?.data, false),
      };
    });

    const otherSheetData = others;
    const predicitionSheetData = predictionandRecommendData?.map(
      (data, index) => {
        const predictedItem = data.predictedItem;
        const recommendedItem = data.recommendedItem;
        return {
          predictIndex: predictedItem.start_date ? index + 1 : "",
          predictType: typeFormatter(predictedItem.type),
          predictStart_date: dateFormatter(predictedItem.start_date),
          predictReason: multipleReasonFormatter(predictedItem.reason),
          recommendIndex: recommendedItem.start_date ? index + 1 : "",
          recommendType: typeFormatter(recommendedItem.type),
          recommendStart_date: dateFormatter(recommendedItem.start_date),
          recommendReason: multipleReasonFormatter(
            recommendedItem.reason_recommended,
          ),
        };
      },
    );

    let benefitSheetDataMessage = "";
    let benefitSheetData = null;
    const { show, data } = benefitsInfo;

    if (show) {
      benefitSheetDataMessage = `${
        exportWorkerTransaltionString[data.benefitsLabel]
      } (${totalbenefitWindow}) : ${data.benefitsValue}`;

      benefitSheetData = [
        {
          financialEnergy: formatDecimal(
            predictionDataRaw?.energy_saving_percent,
          ),
          financialEnergyCost: formattedCurrencyValue(
            predictionDataRaw?.energy_saving_dollars,
          ),
          financialChemical: formatDecimal(
            predictionDataRaw?.chemical_saving_percent,
          ),
          financialChemicalCost: formattedCurrencyValue(
            predictionDataRaw?.chemical_saving_dollars,
          ),
          financialDownTime: formatDecimal(
            predictionDataRaw?.downtime_saving_percent,
          ),
          financialDownTimeCost: formattedCurrencyValue(
            predictionDataRaw?.downtime_saving_dollars,
          ),
          financialDownTimeDays: formatDecimal(
            predictionDataRaw?.downtime_saving_days,
          ),
          financialIncreasedProduction: formatDecimal(
            predictionDataRaw?.increased_production_percent,
          ),
          financialIncreasedProductionCost: formattedCurrencyValue(
            predictionDataRaw?.increased_production_dollars,
          ),
          financialIncreasedProductionVolume: formatVolumeWithUnit(
            predictionDataRaw?.increased_production,
          ),
        },
      ];
    }

    let annualBenefitSheetDataMessage = "";
    let annualBenefitSheetData = null;
    const { show: annualShow, data: annualData } = annualBenefitsInfo;

    if (
      predictionDataRaw?.forcast_window < 365 &&
      predictionDataRaw?.forcast_window > 183 &&
      annualShow
    ) {
      annualBenefitSheetDataMessage = `${
        exportWorkerTransaltionString[annualData.benefitsLabel]
      } (${annualBenefitsWindow}) : ${annualData.benefitsValue}`;

      annualBenefitSheetData = [
        {
          financialEnergy: formatDecimal(
            predictionDataRaw?.annual_energy_saving_percent,
          ),
          financialEnergyCost: formattedCurrencyValue(
            predictionDataRaw?.annual_energy_saving_dollars,
          ),
          financialChemical: formatDecimal(
            predictionDataRaw?.annual_chemical_saving_percent,
          ),
          financialChemicalCost: formattedCurrencyValue(
            predictionDataRaw?.annual_chemical_saving_dollars,
          ),
          financialDownTime: formatDecimal(
            predictionDataRaw?.annual_downtime_saving_percent,
          ),
          financialDownTimeCost: formattedCurrencyValue(
            predictionDataRaw?.annual_downtime_saving_dollars,
          ),
          financialDownTimeDays: formatDecimal(
            predictionDataRaw?.annual_downtime_saving_days,
          ),
          financialIncreasedProduction: formatDecimal(
            predictionDataRaw?.annual_increased_production_percent,
          ),
          financialIncreasedProductionCost: formattedCurrencyValue(
            predictionDataRaw?.annual_increased_production_dollars,
          ),
          financialIncreasedProductionVolume: formatVolumeWithUnit(
            predictionDataRaw?.annual_increased_production,
          ),
        },
      ];
    }

    // processedDataSheetData is now pre-processed before being sent to worker
    const { processedDataSheetData } = event.data.exportData;
    const suggestedOtherSheetData = suggestedOthers || null;

    postMessage({
      predicitionSheetData,
      benefitSheetDataMessage,
      annualBenefitSheetDataMessage,
      benefitSheetData,
      annualBenefitSheetData,
      cipSheetData,
      cleaningEffectinessSheetData,
      foulingSheetData,
      otherSheetData,
      suggestedOtherSheetData,
      processedDataSheetData,
    });
  });
};

export default dataDownloaderWorker;
